/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Settings_Dirs_Toast_Delete_Success_DescInputs */

const es_settings_dirs_toast_delete_success_desc = /** @type {(inputs: Settings_Dirs_Toast_Delete_Success_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} eliminado correctamente.`)
};

const en_settings_dirs_toast_delete_success_desc = /** @type {(inputs: Settings_Dirs_Toast_Delete_Success_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} removed successfully.`)
};

/**
* | output |
* | --- |
* | "{label} removed successfully." |
*
* @param {Settings_Dirs_Toast_Delete_Success_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_toast_delete_success_desc = /** @type {((inputs: Settings_Dirs_Toast_Delete_Success_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Toast_Delete_Success_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_toast_delete_success_desc(inputs)
	return en_settings_dirs_toast_delete_success_desc(inputs)
});
export { settings_dirs_toast_delete_success_desc as "settings.dirs.toast.delete_success_desc" }